import { useIntl } from 'react-intl';
import errorCodeMessages from 'messages/errorCodes';

function useFirebaseError() {
  const intl = useIntl();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (error: any) => {
    // @ts-ignore
    if (error.code && errorCodeMessages[error.code]) {
      // @ts-ignore
      return intl.formatMessage(errorCodeMessages[error.code]);
    }
    return intl.formatMessage(errorCodeMessages.unknown);
  };
}

export default useFirebaseError;
